import L from "./_common.js";
import { createTheme as H } from "../../_mixins/use-theme.js";
import P from "../../_styles/common/light.js";
import M from "../../button/styles/light.js";
import u from "../../checkbox/styles/light.js";
import T from "../../radio/styles/light.js";
import y from "../../pagination/styles/light.js";
import w from "../../_internal/scrollbar/styles/light.js";
import z from "../../empty/styles/light.js";
import D from "../../popover/styles/light.js";
import B from "../../ellipsis/styles/light.js";
import j from "../../dropdown/styles/light.js";
import { composite as o } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function k(n) {
  const {
    cardColor: e,
    modalColor: i,
    popoverColor: l,
    textColor2: C,
    textColor1: m,
    tableHeaderColor: t,
    tableColorHover: r,
    iconColor: h,
    primaryColor: p,
    fontWeightStrong: g,
    borderRadius: c,
    lineHeight: b,
    fontSizeSmall: f,
    fontSizeMedium: v,
    fontSizeLarge: s,
    dividerColor: a,
    heightSmall: S,
    opacityDisabled: x,
    tableColorStriped: d
  } = n;
  return Object.assign(Object.assign({}, L), {
    actionDividerColor: a,
    lineHeight: b,
    borderRadius: c,
    fontSizeSmall: f,
    fontSizeMedium: v,
    fontSizeLarge: s,
    borderColor: o(e, a),
    tdColorHover: o(e, r),
    tdColorSorting: o(e, r),
    tdColorStriped: o(e, d),
    thColor: o(e, t),
    thColorHover: o(o(e, t), r),
    thColorSorting: o(o(e, t), r),
    tdColor: e,
    tdTextColor: C,
    thTextColor: m,
    thFontWeight: g,
    thButtonColorHover: r,
    thIconColor: h,
    thIconColorActive: p,
    // modal
    borderColorModal: o(i, a),
    tdColorHoverModal: o(i, r),
    tdColorSortingModal: o(i, r),
    tdColorStripedModal: o(i, d),
    thColorModal: o(i, t),
    thColorHoverModal: o(o(i, t), r),
    thColorSortingModal: o(o(i, t), r),
    tdColorModal: i,
    // popover
    borderColorPopover: o(l, a),
    tdColorHoverPopover: o(l, r),
    tdColorSortingPopover: o(l, r),
    tdColorStripedPopover: o(l, d),
    thColorPopover: o(l, t),
    thColorHoverPopover: o(o(l, t), r),
    thColorSortingPopover: o(o(l, t), r),
    tdColorPopover: l,
    boxShadowBefore: "inset -12px 0 8px -12px rgba(0, 0, 0, .18)",
    boxShadowAfter: "inset 12px 0 8px -12px rgba(0, 0, 0, .18)",
    // loading
    loadingColor: p,
    loadingSize: S,
    opacityLoading: x
  });
}
const A = H({
  name: "DataTable",
  common: P,
  peers: {
    Button: M,
    Checkbox: u,
    Radio: T,
    Pagination: y,
    Scrollbar: w,
    Empty: z,
    Popover: D,
    Ellipsis: B,
    Dropdown: j
  },
  self: k
}), Q = A;
export {
  Q as default,
  k as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/styles/light.js
// module id = 1623
// module chunks = 41